import { fieldTypes, valueTypes } from '../../../types/common/commonTypes'
import { partFields, partState } from '../../../types/part/partTypes'

export const initialPartState: partState = {
    fields: [
        {
            field: partFields.warehouseRow,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Ряд',
            specialProps: {
                placeholder: 'введите номер ряда',
                column: 2,
                borderTop: false,
                maxLength: 100,
            },
        },
        {
            field: partFields.warehouseShelf,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Полка',
            specialProps: {
                placeholder: 'введите номер полки',
                column: 2,
                borderTop: false,
                maxLength: 100,
            },
        },
        {
            field: partFields.warehousePlace,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Место',
            specialProps: {
                placeholder: 'введите номер места',
                column: 2,
                borderTop: false,
                maxLength: 100,
            },
        },
        {
            field: partFields.warehouseSection,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Секция',
            specialProps: {
                placeholder: '01-02-03-04-05',
                column: 2,
                borderTop: false,
                maxLength: 100,
            },
        },
    ],
}
